export default "__VITE_ASSET__7e3ed4e1__"